module.exports = __webpack_public_path__ + "img/login-img.2ff57419.png";